<div class="card-body p-0">
    <div class="row">
        <div class="col-12">

            <div class="rana-page-header">
                <div>
                    <h1 class="rana-page-title" style="font-size:22px;">Search Member</h1>
                    <p class="rana-page-subtitle mb-0">Look up a member's profile by name or email.</p>
                </div>
            </div>

            <!-- Search Input -->
            <div class="form-group" style="position: relative;">
                <input type="text"
                       class="form-style big form-style-with-icon section-shadow-blue"
                       placeholder="Search by name or email"
                       (input)="onEmailInput($event)"
                       (focus)="onSearchFocus()"
                       (blur)="hideDropdownWithDelay()"/>
                <i class="input-icon big uil uil-search"></i>

                <!-- Autocomplete dropdown -->
                <ul *ngIf="showUserDropdown && filteredUsers.length > 0" class="rana-search-dropdown">
                    <li *ngFor="let user of filteredUsers" (mousedown)="selectUser(user)">
                        <div class="rana-avatar rana-search-dropdown-avatar">{{ userInitials(user) }}</div>
                        <div class="min-width-0">
                            <div class="rana-search-dropdown-name">{{ user.firstname }} {{ user.lastname }}</div>
                            <div class="rana-search-dropdown-email">{{ user.email }}</div>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Empty state -->
            <div class="rana-panel text-center py-5 mt-3" *ngIf="!selectedUser">
                <i class="uil uil-users-alt size-40 color-primary mb-2 d-block"></i>
                <strong class="d-block mb-1">No member selected</strong>
                <p class="mb-0 text-muted">Start typing a name or email above to find a member.</p>
            </div>

            <!-- Profile Card -->
            <div *ngIf="selectedUser" class="rana-detail-card mt-3">

                <div class="rana-detail-header">
                    <img *ngIf="uploadedImageUrl" [src]="uploadedImageUrl" class="rana-detail-photo"/>
                    <div *ngIf="!uploadedImageUrl" class="rana-avatar rana-detail-avatar">{{ userInitials(selectedUser) }}</div>

                    <div class="rana-detail-header-text">
                        <h1 class="rana-detail-title">{{ selectedUser.firstname }} {{ selectedUser.lastname }}</h1>
                        <div class="rana-detail-meta">
                            <span class="rana-badge" [ngClass]="selectedUser.memberType?.includes('Non') ? 'rana-badge-neutral' : 'rana-badge-success'">
                                {{ selectedUser.memberType || 'N/A' }}
                            </span>
                            <ng-container *ngIf="selectedUser.userType">
                                <span class="rana-detail-meta-dot">&middot;</span>
                                <span>{{ selectedUser.userType }}</span>
                            </ng-container>
                            <ng-container *ngIf="selectedUser.chapterAffiliation">
                                <span class="rana-detail-meta-dot">&middot;</span>
                                <span>{{ selectedUser.chapterAffiliation }}</span>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="rana-detail-divider"></div>

                <div class="rana-detail-content">
                    <div class="rana-info-row mb-0">
                        <div class="rana-info-card">
                            <div class="rana-info-icon info"><i class="uil uil-envelope"></i></div>
                            <div class="min-width-0">
                                <div class="rana-info-label">Email</div>
                                <div class="rana-info-value">{{ selectedUser.email || 'N/A' }}</div>
                            </div>
                        </div>
                        <div class="rana-info-card">
                            <div class="rana-info-icon success"><i class="uil uil-phone"></i></div>
                            <div class="min-width-0">
                                <div class="rana-info-label">Phone</div>
                                <div class="rana-info-value">{{ selectedUser.phone || 'N/A' }}</div>
                            </div>
                        </div>
                        <div class="rana-info-card">
                            <div class="rana-info-icon"><i class="uil uil-heart"></i></div>
                            <div class="min-width-0">
                                <div class="rana-info-label">Spouse Name</div>
                                <div class="rana-info-value">{{ selectedUser.spouseName || 'N/A' }}</div>
                            </div>
                        </div>
                        <div class="rana-info-card">
                            <div class="rana-info-icon info"><i class="uil uil-shield-check"></i></div>
                            <div class="min-width-0">
                                <div class="rana-info-label">Application Status</div>
                                <div class="rana-info-value">{{ selectedUser.applicationStatus || 'N/A' }}</div>
                            </div>
                        </div>
                        <div class="rana-info-card">
                            <div class="rana-info-icon"><i class="uil uil-map-marker"></i></div>
                            <div class="min-width-0">
                                <div class="rana-info-label">Chapter</div>
                                <div class="rana-info-value">{{ selectedUser.chapterAffiliation || 'N/A' }}</div>
                            </div>
                        </div>
                        <div class="rana-info-card">
                            <div class="rana-info-icon success"><i class="uil uil-calendar-alt"></i></div>
                            <div class="min-width-0">
                                <div class="rana-info-label">Member Since</div>
                                <div class="rana-info-value">{{ selectedUser.createDate || 'N/A' }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4" *ngIf="selectedUserWithAdditionalDetails && selectedUserWithAdditionalDetails.aboutMe">
                        <div class="rana-panel-title">About</div>
                        <app-rt-editor [disabled]="true" [ngModel]="selectedUserWithAdditionalDetails.aboutMe"></app-rt-editor>
                    </div>
                </div>

                <div class="rana-detail-actions" *ngIf="!(selectedUserWithAdditionalDetails && selectedUserWithAdditionalDetails.aboutMe)">
                    <button type="button" class="rana-action-btn" (click)="getAdditionalDetails()">
                        <i class="uil uil-angle-down"></i> Show more
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>
